let TimelineStepStatus = function (TimelineStepStatus) {
  TimelineStepStatus["Alert"] = "Alert";
  TimelineStepStatus["InProgress"] = "InProgress";
  TimelineStepStatus["Success"] = "Success";
  return TimelineStepStatus;
}({});

export { TimelineStepStatus };
